 export const SplashLoader = ({icon, text}: {icon?:string, text?:string}) => {
    
    return (
<div className="d-flex justify-content-center align-items-center min-vh-100 w-100">
      <div className="d-flex flex-column text-center">
  {icon && <img
          height={"100rem"}
          width={"100rem"}
          className="popup-trash-imagess align-self-center"
          src={icon}
          alt="Trash Icon"
        />}
        {text && <p>{text}</p>}
            <div className="spinner-border text-success align-self-center mt-2" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
      </div>
            
          </div>
    )
 }